import { BaseTag } from 'mixs/base/base_mixin';
import { Scopes }  from 'apps/scopes';

class Daily extends BaseTag {
  has_design(){    return this.design_tasks() != null; }
  has_modeling(){  return this.modeling_tasks() != null; }
  has_casting(){   return this.casting_tasks() != null; }
  has_finishing(){ return this.finishing_tasks() != null; }
  has_process(){   return this.process_tasks() != null; }
  has_check(){     return this.check_tasks() != null; }
  has_delivery(){  return this.delivery_tasks() != null;}
  has_others(){    return this.others_tasks() != null;}

  phase_tasks(id){
    if(this.opts.tasks == null){ return null; }
    if(id == ''){ return null; }
    return this.opts.tasks[id];
  }

  design_tasks(){    return this.phase_tasks(this.design_id()); }
  modeling_tasks(){  return this.phase_tasks(this.modeling_id()); }
  casting_tasks(){   return this.phase_tasks(this.casting_id()); }
  finishing_tasks(){ return this.phase_tasks(this.finishing_id()); }
  process_tasks(){   return this.phase_tasks(this.process_id()); }
  check_tasks(){     return this.phase_tasks(this.check_id()); }
  delivery_tasks(){  return this.phase_tasks(this.delivery_id()); }
  others_tasks(){    return this.phase_tasks(this.others_id()); }

  phase_id(scope){
    if(this.parent.opts.phases[scope] == null){ return '';}
    return this.parent.opts.phases[scope].id
  }
  design_id(){    return this.phase_id('design'); }
  modeling_id(){  return this.phase_id('modeling'); }
  casting_id(){   return this.phase_id('casting'); }
  finishing_id(){ return this.phase_id('finishing'); }
  process_id(){   return this.phase_id('process'); }
  check_id(){     return this.phase_id('check'); }
  delivery_id(){  return this.phase_id('delivery'); }
  others_id(){    return this.phase_id('others'); }
  bg_date(){
    if(this.opts.week == '0'){ return '#ff5252'; }
    if(this.opts.week == '6'){ return '#448aff'; }
    return '#28a745'
  }
}

riot.mixin('calendars.daily', Daily as riot.TagMixin)
